import React, { useEffect, useState } from 'react';
import InventorySpreadsheet from './InventorySpreadsheet';
import InventoryViewer from './InventoryViewer';
import CountInterface from './CountInterface';
import Settings from './Settings';

const SimpleInventoryManager = () => {
  const [activeTab, setActiveTab] = useState('list');
  const [initialSettingsTab, setInitialSettingsTab] = useState(null);

  useEffect(() => {
    // Check localStorage first (used by internal navigation)
    const openSettingsTab = localStorage.getItem('openSettingsTab');
    if (openSettingsTab) {
      localStorage.removeItem('openSettingsTab');
      setInitialSettingsTab(openSettingsTab);
      setActiveTab('settings');
      return;
    }
    // Also check URL ?tab= param (used by OAuth callbacks, external redirects)
    const urlTab = new URLSearchParams(window.location.search).get('tab');
    if (urlTab) {
      setInitialSettingsTab(urlTab);
      setActiveTab('settings');
    }
  }, []);

  // Handle saving data from the spreadsheet
  const handleSaveInventory = async (data) => {
    try {
      console.log('Saving inventory data:', data);
      
      // Here you would normally send the data to your backend API
      // For now, we'll just simulate success
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      alert(`Successfully saved ${data.length} inventory items!`);
      setActiveTab('list'); // Switch back to the list view
      
      // In a real app, you'd refresh the inventory list here
    } catch (error) {
      console.error('Error saving inventory:', error);
      alert('Error saving inventory. Please try again.');
      throw error;
    }
  };

  // Handle canceling from the spreadsheet
  const handleCancelSpreadsheet = () => {
    setActiveTab('list');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'add':
        return (
          <div className="card">
            <div className="card-body">
              <h6>Add Items (Spreadsheet)</h6>
              <InventorySpreadsheet 
                onSave={handleSaveInventory}
                onCancel={handleCancelSpreadsheet}
              />
            </div>
          </div>
        );
      case 'import':
        return (
          <div className="card">
            <div className="card-body">
              <h6>Import from File</h6>
              <p>This will contain the Uppy file upload component.</p>
              <div className="alert alert-info">
                <strong>Import Features:</strong>
                <ul className="mb-0 mt-2">
                  <li>Drag & drop file upload</li>
                  <li>Support for CSV and Excel files</li>
                  <li>File validation (size, type)</li>
                  <li>Bulk import processing</li>
                  <li>Error reporting</li>
                </ul>
              </div>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <i className="feather icon-upload text-gray-400 text-4xl mb-3"></i>
                <p className="text-gray-600 mb-2">Drop your CSV or Excel file here</p>
                <p className="text-gray-500 text-sm">or click to browse</p>
              </div>
              <div className="mt-3">
                <button className="btn btn-secondary me-2" onClick={() => setActiveTab('list')}>
                  Cancel
                </button>
                <button className="btn btn-primary">
                  Upload & Import
                </button>
              </div>
            </div>
          </div>
        );

      case 'perform-count':
        return (
          <CountInterface
            onCancel={() => setActiveTab('list')}
          />
        );
      case 'settings':
        return (
          <Settings
            onCancel={() => setActiveTab('list')}
            initialActiveTab={initialSettingsTab}
          />
        );
      default:
        return <InventoryViewer />;
    }
  };

  return (
    <div className="inventory-manager">
      {/* Header with Action Buttons */}
      <div className="card mb-4">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Catalog & Prices</h5>
            <div className="btn-group">
              <button 
                className={`btn ${activeTab === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setActiveTab('list')}
              >
                <i className="feather icon-list me-2"></i>
                View All
              </button>
              <button 
                className={`btn ${activeTab === 'add' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setActiveTab('add')}
              >
                <i className="feather icon-plus me-2"></i>
                Add Items
              </button>
              <button
                className={`btn ${activeTab === 'import' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setActiveTab('import')}
              >
                <i className="feather icon-upload me-2"></i>
                Import
              </button>


              <button
                className={`btn ${activeTab === 'perform-count' ? 'btn-success' : 'btn-outline-success'}`}
                onClick={() => setActiveTab('perform-count')}
              >
                <i className="feather icon-check-square me-2"></i>
                Count
              </button>
              <button
                className={`btn ${activeTab === 'settings' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setActiveTab('settings')}
              >
                <i className="feather icon-settings me-2"></i>
                Settings
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {renderTabContent()}


    </div>
  );
};

export default SimpleInventoryManager;
